import { FormLabel, FormLabelProps } from '@chakra-ui/react';
import React from 'react';
import { TEXT_STYLES } from '../../../design-system';

const variantMap = {
  label: {
    ...TEXT_STYLES.heading_3,
  },

  subLabel: {
    ...TEXT_STYLES.paragraph,
  },
};

interface KFormLabelProps extends FormLabelProps {
  variant?: keyof typeof variantMap;
}

export const KFormLabel = ({
  variant = 'label',
  children,
  htmlFor,
  ...props
}: KFormLabelProps) => {
  const styles = variantMap[variant];

  return (
    <FormLabel htmlFor={htmlFor} {...styles} {...props}>
      {children}
    </FormLabel>
  );
};
